import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/guide',
      name: 'guide',
      component: () => import('../views/Guide.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/paid-extras',
      name: 'paidExtras',
      component: () => import('../views/PaidExtrasLanding.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/paid-extras/agency',
      name: 'paidExtrasAgency',
      component: () => import('../views/PaidExtras.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/paid-extras/manage-types',
      name: 'manageAvailablePaidExtras',
      component: () => import('../views/ManageAvailablePaidExtras.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/properties',
      name: 'properties',
      component: () => import('../views/PropertiesLanding.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/properties/list',
      name: 'propertiesList',
      component: () => import('../views/Properties.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/properties/create',
      name: 'propertyCreate',
      component: () => import('../views/PropertiesCreate.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/properties/:id',
      name: 'propertyEdit',
      component: () => import('../views/PropertiesEdit.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/login/password-reset',
      name: 'passwordReset',
      component: () => import('../views/PasswordReset.vue'),
      meta: { requiresAuth: false },
      alias: ['/login/reset-password', '/password-reset'],
    },
    {
      path: '/login/verify',
      name: 'loginVerify',
      component: () => import('../views/LoginVerify.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import('../views/Dashboard.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/Settings.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('../views/UsersLanding.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/users/list',
      name: 'usersList',
      component: () => import('../views/Users.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/users/:id',
      name: 'userDetail',
      component: () => import('../views/UserDetail.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/roles',
      name: 'roles',
      component: () => import('../views/Roles.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/permissions',
      name: 'permissions',
      component: () => import('../views/Permissions.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/agencies',
      name: 'agencies',
      component: () => import('../views/AgenciesLanding.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/agencies/list',
      name: 'agenciesList',
      component: () => import('../views/Agencies.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/agencies/onboard',
      name: 'onboardBroker',
      component: () => import('../views/OnboardBroker.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/agencies/subscriptions',
      name: 'subscriptions',
      component: () => import('../views/Subscriptions.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/agencies/lead-contact',
      redirect: '/leads/broker-contact',
    },
    {
      path: '/subscriptions',
      redirect: '/agencies/subscriptions',
    },
    {
      path: '/leads/broker-contact',
      name: 'brokerLeadContact',
      component: () => import('../views/BrokerLeadContact.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/leads',
      name: 'leads',
      component: () => import('../views/Leads.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/leads/:id',
      name: 'leadDetail',
      component: () => import('../views/LeadDetail.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/search-order-config',
      name: 'searchOrderConfig',
      component: () => import('../views/SearchOrderConfig.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/assets',
      name: 'assets',
      component: () => import('../views/Assets.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations',
      name: 'integrations',
      component: () => import('../views/Integrations.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/overview',
      name: 'integrationsOverview',
      component: () => import('../views/IntegrationsOverview.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/kyero',
      name: 'kyeroIntegrations',
      component: () => import('../views/KyeroIntegrations.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/scrapers',
      name: 'scrapers',
      component: () => import('../views/Scrapers.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/mapbox-cron',
      name: 'mapboxCron',
      component: () => import('../views/MapboxCronJobs.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/openai-cron',
      name: 'openaiCron',
      component: () => import('../views/OpenAICronJobs.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/member-outbound',
      name: 'memberOutbound',
      component: () => import('../views/MemberOutbound.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/meta-insights',
      name: 'metaSearchInsights',
      component: () => import('../views/MetaSearchInsights.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/agencies/bostello-sites',
      name: 'bostelloAgencySites',
      component: () => import('../views/BrokerSiteOnboard.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integrations/broker-sites',
      redirect: '/agencies/bostello-sites',
    },
    {
      path: '/property-card-ads',
      name: 'propertyCardAds',
      component: () => import('../views/PropertyCardAds.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('../views/NotFound.vue'),
    },
  ],
})

// Log router errors during development to aid debugging
if (import.meta.env.DEV) {
  router.onError(err => {
    console.error('Vue Router error during navigation:', err)
  })
}

// Export a function to setup navigation guards after Pinia is initialized
export async function setupRouter(app: any) {
  // Import auth store only after Pinia is available
  const { useAuthStore } = await import('../stores/auth')

  // Global navigation guard
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    console.log(`Router guard: Navigating to ${to.path}, requiresAuth: ${to.meta.requiresAuth}`)

    // Check if route requires authentication
    if (to.meta.requiresAuth !== false) {
      // Always check session for protected routes if not already checked
      if (!authStore.hasCheckedSession) {
        try {
          console.log('Router guard: Session not checked yet, checking now...')
          await authStore.checkSession()
          console.log(
            'Router guard: Session check completed, authenticated:',
            authStore.isAuthenticated
          )
        } catch (error) {
          console.error('Router guard: Session check failed:', error)
          // Even if session check fails, let the auth store handle the state
        }
      } else {
        console.log(
          'Router guard: Session already checked, authenticated:',
          authStore.isAuthenticated
        )
      }

      // Wait a brief moment for any pending authentication state changes
      await new Promise(resolve => setTimeout(resolve, 100))

      // Debug the current auth state
      console.log('Router guard: Current auth state:', {
        user: authStore.user,
        isAuthenticated: authStore.isAuthenticated,
        hasCheckedSession: authStore.hasCheckedSession,
        isLoading: authStore.isLoading,
      })

      // If still not authenticated after session check, redirect to login
      if (!authStore.isAuthenticated) {
        console.log('Router guard: Not authenticated, redirecting to login')
        console.log('Router guard: User value:', authStore.user)
        next('/login')
        return
      }
    }

    // If user is authenticated and trying to access login, redirect to dashboard
    if (to.name === 'login' && authStore.isAuthenticated) {
      console.log('Router guard: Already authenticated, redirecting to dashboard')
      next('/')
      return
    }

    // Do not trigger session check on login route to prevent instant re-login after signout
    if (to.name === 'login') {
      next()
      return
    }

    console.log('Router guard: Allowing navigation to', to.path)
    next()
  })

  return router
}

export default router
